import React, { useState, useEffect } from 'react';
import './GameCountdown.css';

const STEPS = ['3', '2', '1', 'GO!'];
const STEP_DURATION = 850; // ms per number
const GO_DURATION = 600;   // ms for GO! before transitioning

function GameCountdown({ onComplete }) {
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    if (stepIndex < STEPS.length - 1) {
      const timer = setTimeout(() => setStepIndex(i => i + 1), STEP_DURATION);
      return () => clearTimeout(timer);
    } else {
      // On "GO!", wait briefly then transition
      const timer = setTimeout(onComplete, GO_DURATION);
      return () => clearTimeout(timer);
    }
  }, [stepIndex, onComplete]);

  const step = STEPS[stepIndex];
  const isGo = step === 'GO!';

  return (
    <div className="countdown-overlay">
      {/* Radiating ring burst */}
      <div className={`countdown-ring countdown-ring--${stepIndex}`} key={`ring-${stepIndex}`} />
      <div className={`countdown-ring countdown-ring-inner countdown-ring--${stepIndex}`} key={`ring2-${stepIndex}`} />

      <div className={`countdown-number ${isGo ? 'countdown-go' : ''}`} key={step} data-step={step}>
        {step}
      </div>

      {/* Particle dots that fly outward on each beat */}
      <div className="countdown-particles" key={`p-${stepIndex}`}>
        {Array.from({ length: 12 }).map((_, i) => (
          <div
            key={i}
            className="countdown-particle"
            style={{
              '--angle': `${i * 30}deg`,
              '--delay': `${i * 25}ms`,
              '--hue': isGo ? '160' : `${200 + stepIndex * 30}`,
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default GameCountdown;
